/* globals document */
/* eslint react/jsx-filename-extension: "off" */

import React, { Component } from "react";
import { connect } from "react-redux";
import BrowserRouter from "react-router/BrowserRouter";
import Match from "react-router/Match";
import Miss from "react-router/Miss";
import Redirect from "react-router/Redirect";
import Header from "./Header";
import Footer from "./Footer";
import FrontPage from "./FrontPage";
import GroupSettings from "./GroupSettings";
import GroupExercises from "./GroupExercises";
import GuestLayout from "./GuestLayout";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import Register from "./Register";
import TrialTokenRegistration from "./TrialTokenRegistration";
import Pronounce from "./Pronounce";
import NoAuthorization from "./NoAuthorization";
import JoinGroup from "./JoinGroup";
import Account from "./Account";
import About from "./About";
import Privacy from "./Privacy";
import Terms from "./Terms";
import Welcome from "./Welcome";
import LandingPage from "./LandingPage";

import { getSubscriptions, setFirstLogin } from "../actions/actions";
import "../index.css";
import device from "../modules/device";

const justPronounce = false;
const standAlone = false;

// Expose a small global config object - this is used just for Google
// Analytics at the moment. Modifying it does nothing.
window.pronounceConfig = {
  lang: "en-GB"
};

class App extends Component {
  constructor() {
    super();

    const dev = device();

    this.state = {
      deviceConfig: {
        type: dev.type,
        environment: dev.environment
      },
      openWelcomeScreen: false,
      openIntroductoryExercise: false
    };
  }

  componentWillMount() {
    // uses matchMedia API to detect changes in width for responsive layouts.
    this.queryTablet = window.matchMedia("(max-width: 768px)");
    this.queryPhone = window.matchMedia("(max-width: 480px)");

    this.queryTablet.addListener(this.mediaQueryChanged);
    this.queryPhone.addListener(this.mediaQueryChanged);

    const deviceConfig = { ...this.state.deviceConfig };
    deviceConfig.isTablet = this.queryTablet.matches;
    deviceConfig.isPhone = this.queryPhone.matches;

    this.setState({ deviceConfig });

    //Check for access here, in case the user has stored their logins with the Remember button
    if (this.props.auth.isAuthenticated) {
      this.props.dispatch(getSubscriptions());
    }
  }

  componentDidUpdate(prevProps) {
    const prevAuth = prevProps.auth.isAuthenticated;
    const auth = this.props.auth.isAuthenticated;

    // Start logging time spent in the app
    if (!prevProps.auth.isAuthenticated && this.props.auth.isAuthenticated) {
      localStorage.setItem("pronounce-time-spent", performance.now());

      //If the user is NOT using Remember me, check for access here
      this.props.dispatch(getSubscriptions());
      if (!this.props.auth.localData.hasLoggedIn) {
        //Disabled until storing user prefs locally per user is sorted out
        this.setState({
          openWelcomeScreen: true,
          openIntroductoryExercise: true
        });
        this.props.dispatch(setFirstLogin());
      }
    }
  }

  componentWillUnmount() {
    this.queryTablet.removeListener(this.mediaQueryChanged);
    this.queryPhone.removeListener(this.mediaQueryChanged);
  }

  mediaQueryChanged = () => {
    const deviceConfig = { ...this.state.deviceConfig };
    deviceConfig.isTablet = this.queryTablet.matches;
    deviceConfig.isPhone = this.queryPhone.matches;

    this.setState({ deviceConfig });
  };

  openWelcome = () => this.setState({ openWelcomeScreen: true });

  closeWelcome = () => this.setState({ openWelcomeScreen: false });

  render() {
    const { dispatch } = this.props;
    const { user, isAuthenticated } = this.props.auth;
    const config = this.state.deviceConfig;
    let classes = "";

    if (config.isTablet) {
      classes = `${classes} tablet`;
    }

    if (config.isPhone) {
      classes = `${classes} phone`;
    }

    /*  const MatchWhenAuthorized = ({ component: AuthedComponent, ...rest }) => (
      <Match
        {...rest}
        render={props => (
          user.hasActiveGroup || user.hasActiveSubscription ? (
            <AuthedComponent {...props} {...this.props} />
          ) : (
            <NoAuthorization user={user} />
          )
        )}
      />
  ); */

    // This is a temporary arrangement so that the development of
    // redux-based state management can be continued alongside other features.
    // Use the justPronounce const defined above to control the output
    let app;

    // TODO: There's MatchWhenAuthorized right above, but for some reason it causes an unnecessary
    // rerender. It's bad because the text input for content will lose focus because of it.
    const pronounceApp =
      user.hasActiveGroup ||
      user.hasActiveSubscription ||
      user.onTrial ||
      user.onGenericTrial ? (
        <Pronounce
          config={config}
          standAlone={standAlone}
          openIntro={this.state.openIntroductoryExercise}
          {...this.props}
        />
      ) : (
        <Redirect
          to={{
            pathname: "/account/subscription",
            state: { from: this.props.location }
          }}
        />
      );

    if (justPronounce) {
      app = (
        <div className={`pronounce${classes}`}>
          <Pronounce
            {...this.props}
            config={config}
            standAlone={standAlone}
            justPronounce={justPronounce}
          />
        </div>
      );
    } else if (isAuthenticated) {
      app = (
        <div>
          <Header
            dispatch={dispatch}
            auth={this.props.auth}
            subscriptions={this.props.subscriptions}
            showWelcomeScreen={this.openWelcome}
          />
          <div className={`pronounce ${classes}`}>
            <Match exactly pattern="/" render={() => pronounceApp} />

            <Match
              pattern="/register"
              render={props => <Register {...props} {...this.props} />}
            />
            <Match
              strict
              pattern="/register/"
              render={props => <Register {...props} {...this.props} />}
            />
            <Match
              pattern="/account"
              render={props => <Account {...props} {...this.props} />}
            />
            <Match
              exactly
              pattern="/account/join-group"
              render={props => <JoinGroup {...props} {...this.props} />}
            />
            <Match
              exactly
              pattern="/group-settings"
              render={props => <GroupSettings {...props} {...this.props} />}
            />
            <Match
              exactly
              pattern="/group-settings/exercises"
              render={props => <GroupExercises {...props} {...this.props} />}
            />
            <Match pattern="/about" component={About} />
            <Match pattern="/privacy" component={Privacy} />
            <Match pattern="/terms" component={Terms} />
            <Miss render={() => <Redirect to={{ pathname: "/" }} />} />
            <Welcome
              open={this.state.openWelcomeScreen}
              handleClose={this.closeWelcome}
              auth={this.props.auth}
            />
          </div>
        </div>
      );
    } else {
      app = (
        <GuestLayout classes={classes} {...this.props}>
          <Match
            exactly
            pattern="/"
            render={props => <FrontPage {...props} {...this.props} />}
          />
          <Match
            exactly
            pattern="/register"
            render={props => <Register {...props} {...this.props} />}
          />
          {/*<Match pattern="/start-trial/:resetToken" render={props => <TrialTokenRegistration {...props} {...this.props} />} />*/}
          <Match
            exactly
            pattern="/password/email"
            render={props => <ForgotPassword {...props} {...this.props} />}
          />
          <Match
            pattern="/password/reset/:resetToken"
            render={props => <ResetPassword {...props} {...this.props} />}
          />
          <Match pattern="/about" component={About} />
          <Match pattern="/privacy" component={Privacy} />
          <Match pattern="/terms" component={Terms} />
          <Match
            pattern="/create-account-android"
            render={props => <LandingPage {...props} {...this.props} />}
          />
          <Miss render={() => <Redirect to={{ pathname: "/" }} />} />
          <Footer />
        </GuestLayout>
      );
    }

    return <BrowserRouter>{app}</BrowserRouter>;
  }
}

// These props come from the application's
// state when it is started
function mapStateToProps(state) {
  const {
    isWaiting,
    exercises,
    group,
    text,
    history,
    auth,
    validation,
    registration,
    trialregistration,
    singleregistration,
    joinGroup,
    subscriptions,
    invoices
  } = state;

  return {
    isWaiting,
    auth,
    registration,
    trialregistration,
    singleregistration,
    joinGroup,
    subscriptions,
    invoices,
    exercises,
    group,
    text,
    history,
    validation
  };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js